export const isVideoUIVisible = state => state.get('video').get('isVideoUIVisible')
